import { GenericResponse } from ".";
import { SIP_TYPE_VALUE } from "../constants";

export type InvestForm = LumpsumDetails &
  SipDetails &
  DistributorDetails & {
    option: string;
    payFirstInstallment: boolean;
    schemeName: string;
    isEnachMandateFlow?: boolean;
    selectedInvestTab?: string;
  };

export type LumpsumDetails = {
  lumpsumAmount: number | undefined;
};
export type Option = {
  label: string;
  value: string;
};

export type SipDetails = {
  sipAmount: number | undefined;
  sipFrequency: string;
  sipStartDate: Date | null;
  sipType: SIP_TYPE_VALUE;
  installments: number | undefined;
};
export type SipMobileDetails = {
  sipAmount: number | undefined;
};

export type InvestmentType = {
  lable: string;
  value: number;
};

export enum MODES_OF_INVESTMENT {
  DIRECT = "DIRECT",
  REGULAR = "REGULAR",
}

export type DistributorDetails = {
  modeOfInvestment: MODES_OF_INVESTMENT;
  riaCode?: string;
  isRiaValid?: boolean;
  arnCode?: string;
  isArnValid?: boolean;
  subBroker?: string;
  subBrokerArn?: string;
  euin?: string;
  isEuinValid?: boolean;
};

export interface PerformanceMetric {
  Title: string;
  Period: string;
  percent: string;
  benchmarkPercent: string;
  value: string;
  benchmarkValue: string;
}

export interface FundPerformance {
  "6m": PerformanceMetric;
  "1y": PerformanceMetric;
  "3y": PerformanceMetric;
  "5y": PerformanceMetric;
  "7y": PerformanceMetric;
  "10y": PerformanceMetric;
  sinceInception: PerformanceMetric;
}

export interface FundDetails {
  id: string;
  fund: string;
  scheme: string;
  schdesc: string;
  plandesc: string;
  optiondesc: string;
  plan: string;
  plnmode: string;
  option: string;
  mcrid: string;
  category: string;
  fm_category?: string;
  fm_sebischemecategory?: string;
  fm_opendate?: string | null;
  fm_closedate?: string | null;
  fm_reopendate?: string | null;
  nfoStatus?: "NFO_OPEN" | "NFO_CLOSED" | "NORMAL";
  purallow: "Y" | "N";
  redallow: "Y" | "N";
  sipallow: "Y" | "N";
  stpiallow: "Y" | "N";
  swiallow: "Y" | "N";
  swoallow: "Y" | "N";
  latiallow: "Y" | "N";
  latoallow: "Y" | "N";
  minAmt?: number;
  multiples?: number;
  collection?: string;
  value?: string;
  performance?: FundPerformance;
  sebi_category?: string;
  sebi_subcategory?: string;
  other_schemes?: string;
  nav: string;
  navDate: string;
  navPercentage: string;
  inceptionDate: string;
  isMostBoughtFund?: boolean;
  mostBoughtFundValue?: string;
  isPopularSipFund?: boolean;
  popularSipFundValue?: string;
  isDailySip?: boolean;
  Category?: string;
  Title?: string;
  SchemeCode?: string;
  fm_optiondesc?: string;
}

export interface FundDetailsResponse
  extends GenericResponse<
    {
      fm_fund: string;
      fm_scheme: string;
      fm_schdesc: string;
      fm_plandesc: string;
      fm_optiondesc: string;
      fm_plan: string;
      fm_plnmode: string;
      fm_option: string;
      fm_mcrid: string;
      fm_category: string;
      fm_opendate: string | null;
      fm_closedate: string | null;
      fm_reopendate: string | null;
      fm_purallow: "Y" | "N";
      fm_redallow: "Y" | "N";
      fm_sipallow: "Y" | "N";
      fm_stpiallow: "Y" | "N";
      fm_swiallow: "Y" | "N";
      fm_swoallow: "Y" | "N";
      fm_latiallow: "Y" | "N";
      fm_latoallow: "Y" | "N";
      minAmt?: number;
      multiples?: number;
      collection?: string;
      value?: string;
      performance?: FundPerformance;
      sebi_category?: string;
      sebi_subcategory?: string;
      "Other Schemes"?: string;
      NavAmount: number;
      NavDate: string;
      NavPercent: string;
      InceptionDate: string;
      isMostBoughtFund: "Y" | "N";
      mostBoughtFundValue: string;
      isPopularSipFund: "Y" | "N";
      popularSipFundValue: string;
      isDailySip: "Y" | "N";
      Category: string;
      Title: string;
      SchemeCode: string;
    }[]
  > {}

export interface SchemeOption {
  optiondesc: string;
  optioncode: string;
}

export interface SchemePlan {
  plandesc: string;
  plancode: string;
  options: SchemeOption[];
}

export interface SchemeOptionsData {
  DIRECT?: SchemePlan[];
  REGULAR?: SchemePlan[];
  [key: string]: SchemePlan[] | undefined;
}

export interface SchemeOptionsResponse extends GenericResponse<SchemeOptionsData> {}

export interface SchemeOptionsRequest {
  scheme: string;
}

export type PerformancePeriod =
  | "6m"
  | "1y"
  | "3y"
  | "5y"
  | "7y"
  | "10y"
  | "sinceInception";

export interface PerformanceData {
  Title: string;
  Period: string;
  percent: string;
  benchmarkPercent: string;
  value: string;
  benchmarkValue: string;
}
